<fou-group class="messageSectionContainer">
  <fou-container :id="$vId(this, 'message-history')" cols="12" background>
    <template #header>
      <h5 class="mt-h5">
        {{$t('pages.submissions.review.history.title')}}
        {{`(${messageHistory ? messageHistory.length : 0}).`}}
      </h5>
    </template>
    <template #content>
      <v-grid>
        <v-row>
          <v-col has="10" off="1">
            <div class="out-left out-right">
              <section class="mt-section">
                <div
                  v-for="(message, index) in messageHistory"
                  :class="[ $style.bgDesign, {[$style.messageHistorySection] : (index !=0)}]"
                  v-show="index !==0 ? messageSectionVisible : true"
                >
                  <template v-if="message.sendertype === 'foundryUser'">
                    <div :class="$style.bgSupport">
                      <div :class="$style.dateTimeSection">
                        <div class="mt-line" :class="$style.foundrySupportName">
                          <div>
                            <span :class="$style.senderName"
                              >{{message.foundryName}}</span
                            >
                          </div>
                        </div>
                        <div
                          class="mt-line"
                          :class="$style.messageDateFoundrySupport"
                        >
                          <div>
                            <span class="mt-serif mt-serif--size5"
                              >{{formatUTCtoEST(message.dateOfMessage, $lang,
                              'MM.DD.YYYY')}}</span
                            >
                          </div>
                        </div>
                        <div
                          class="mt-line"
                          :class="$style.nameAndTimeFoundrySupport"
                        >
                          <div>
                            <span class="mt-serif mt-serif--size5"
                              >{{formatUTCtoEST(message.dateOfMessage, $lang,
                              'LT')}}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div :class="$style.mBtmLeft">
                        <div
                          class="mt-line"
                          :class="$style.messageContentFoundrySupport"
                        >
                          <h4 class="mt-serif mt-serif--size5">
                            {{message.messageContent}}
                          </h4>
                        </div>
                        <div
                          class="mt-line"
                          :class="$style.senderNameFoundrySupport"
                        >
                          <h4 class="mt-serif mt-serif--size5">
                            {{message.senderName}}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div :class="[$style.bgSupport]">
                      <div :class="$style.dateTimeSection">
                        <div class="mt-line" :class="$style.foundrySupportName">
                          <div>
                            <span :class="$style.senderName"
                              >{{$t('pages.submissions.components.messageHistory.foundry_support_team')}}</span
                            >
                          </div>
                        </div>
                        <div
                          class="mt-line"
                          :class="$style.messageDateFoundrySupport"
                        >
                          <div>
                            <span class="mt-serif mt-serif--size5"
                              >{{formatUTCtoEST(message.dateOfMessage, $lang,
                              'MM.DD.YYYY')}}</span
                            >
                          </div>
                        </div>
                        <div
                          class="mt-line"
                          :class="$style.nameAndTimeFoundrySupport"
                        >
                          <div>
                            <span class="mt-serif mt-serif--size5"
                              >{{formatUTCtoEST(message.dateOfMessage, $lang,
                              'LT')}}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div :class="$style.mBtmLeft">
                        <div
                          class="mt-line"
                          :class="$style.messageContentFoundrySupport"
                        >
                          <h4 class="mt-serif mt-serif--size5" v-html="message.messageContent">
                          </h4>
                        </div>
                        <div
                          class="mt-line"
                          :class="$style.senderNameFoundrySupport"
                        >
                          <h4 class="mt-serif mt-serif--size5">
                            {{message.senderName}}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </section>
            </div>
            <template v-if="messageHistory && messageHistory.length > 1">
              <div class="mt-line" :class="$style.expandCollapseButton">
                <div>
                  <a @click.prevent="setMessageSectionVisible"
                    ><span>{{expandButtonText}}</span></a
                  >
                </div>
              </div>
            </template>
          </v-col>
        </v-row>
      </v-grid>
    </template>
  </fou-container>
</fou-group>
